<script>
  // A small ring that fills over the refresh interval, pulses once when a fresh
  // result lands, then starts filling again. Timed from when the result was
  // received locally, so server/client clock skew can't stretch or shrink it.
  import { RING_FLASH_MS, RING_TICK_MS, ringProgress, ringSecondsLeft } from '../../lib/moderation_live.js'

  let { lastUpdatedAt = null, paused = false } = $props()

  let receivedAt = $state(null)
  let progress = $state(0)
  let flash = $state(false)
  let first = true

  $effect(() => {
    if (!lastUpdatedAt) return
    receivedAt = Date.now()
    progress = 0
    // No pulse on the initial load — only on refreshes.
    if (first) {
      first = false
      return
    }
    flash = true
    const timer = setTimeout(() => (flash = false), RING_FLASH_MS)
    return () => clearTimeout(timer)
  })

  $effect(() => {
    if (paused || receivedAt === null) return
    const started = receivedAt
    const tick = () => (progress = ringProgress(started))
    tick()
    const timer = setInterval(tick, RING_TICK_MS)
    return () => clearInterval(timer)
  })

  const shown = $derived(paused ? 0 : progress)
  const title = $derived(paused ? 'Polling paused' : `Next refresh in ${ringSecondsLeft(shown)}s`)
</script>

<span
  class="radial-progress transition-transform duration-300 {paused ? 'text-base-content/30' : 'text-primary'} {flash ? 'scale-150' : ''}"
  style="--value:{shown * 100}; --size:1.125rem; --thickness:2.5px;"
  role="progressbar"
  aria-valuenow={Math.round(shown * 100)}
  aria-label={title}
  {title}
></span>
